import googlePlayIcon from "../../assets/google-play.svg";
import razorpayIcon from "../../assets/razorpay.svg";
import iconsList from "../../assets/icon-list.svg";
import { useDispatch, useSelector } from "react-redux";
import { initialisePaymentService } from "@src/PaymentService";
import { setSelectedPaymentMethodAction } from "../../../../store/actions";

export default function PaymentOptionsScreen({ handleLearnMoreClick }) {
  const dispatch = useDispatch();
  const paymentOptions = useSelector(
    (state) => state?.overviewReducer?.paymentOptions
  );

  const handlePaymentOptionClick = (item) => {
    dispatch(setSelectedPaymentMethodAction(item));
    initialisePaymentService();
  };

  return (
    <div>
      <div className="optionScreenDescription">
        Choose who will secure and process your payment and provide customer
        service. Benefits and available forms of payment may vary.{" "}
        <span className="learnMoreText" onClick={() => handleLearnMoreClick()}>
          Learn More
        </span>
      </div>
      <div style={{ marginTop: "24px" }}>
        {paymentOptions &&
          paymentOptions.length > 0 &&
          paymentOptions.map((item, index) => {
            return (
              <div
                key={index}
                className="paymentOptionCard"
                onClick={() => handlePaymentOptionClick(item)}
              >
                <img
                  height={24}
                  width={24}
                  src={item?.iconURL}
                  alt={`${item.name}`}
                />
                <div>
                  <p className="paymentOptionCardTitle">{item.name}</p>
                  <div className="paymentOptionCardImageList">
                    <img src={item?.iconListURL} />
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
}
